export const STATUS_BADGE_TONES: Record<string, string> = {
  neutral: "border-transparent bg-dash-chip text-dash-muted",
  success: "border-transparent bg-dash-greenMid/[0.12] text-dash-greenMid",
  warning: "border-transparent bg-dash-amber/[0.12] text-dash-amber",
  info: "border-transparent bg-dash-slate/[0.12] text-dash-slate",
  danger: "border-transparent bg-dash-rust/[0.12] text-dash-rust",
  primary: "border-transparent bg-dash-greenDeep text-white",
};

export const TOAST_LIMIT = 1;
export const TOAST_REMOVE_DELAY = 1_000_000;
